const removeFirstSpecialChar = (value: string): string => {
  if (value.at(0) === '*') {
    return value.substring(1);
  } return value;
};

export default removeFirstSpecialChar;
